import { gql } from 'apollo-boost'
export const getSigningPath = gql`
  {
    signingPaths {
      id
      name
      numberOfLevels
      companyId
      company {
        id
        name
      }
      receiverGroup {
        id
        name
      }
      levels {
        level
        approverType
        approverGroupId
        approverGroupName
      }
      description
      isDeployed
      createdOn
      lastModifiedOn
    }
  }
`
//(group/department/manager)
